import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL } from 'app/@common/constants'
import { formatSiteWithLogo } from "app/utils"


export default function SelectCompetitionSites({ ...props }) {

    if (!props.date) return <SelectLoading />
    const isSingleOption = props.totalSites === 1

    const myProps = {
        urlAjax: COMPETITION_URL.SITES,
        placeholder: 'Select site',
        isClearable: false,
        method: 'POST',
        icon: { icon: 'desktop' },
        formatOptionLabel: ({ label }) => formatSiteWithLogo({ siteName: label.toLowerCase() }),
        extraParams: {
            market: props.market,
            dateRange: props.date,
            ...props.refresh && { refresh_cache: props.refresh },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...props.date === 'custom' && { 
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            },
        },
        ...props
    }

    return <div className={isSingleOption ? 'disabled-select' : ''}>
        <SelectAjaxSeeker 
            {...myProps}
        />
        {isSingleOption && <style jsx="true" global="true">{`
            .disabled-select {
                pointer-events: none;
            }
            /* Aseguramos que la flecha desaparezca */
            .disabled-select [class*="indicatorContainer"] svg,
            .disabled-select [class*="IndicatorContainer"] svg,
            .disabled-select [class*="dropdown-indicator"] {
                display: none !important;
            }
        `}</style>}
    </div>
}